
import fiveStarInsurerByYearAndSlug from '@/apollo/queries/5star/fiveStarInsurerByYearAndSlug'
import fiveStarCatByYearAndSlug from '@/apollo/queries/5star/fiveStarCatByYearAndSlug'
import fiveStarPageByYear from '@/apollo/queries/5star/fiveStarPageByYear'

import pageMeta from '~/mixins/pageMeta.js';
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import eventTrackingFiveStarFnMixins from '~/mixins/eventTrackingFiveStarFnMixins';

export default {
    mixins: [pageMeta, eventTrackingMixins, eventTrackingFiveStarFnMixins],
    data() {
        return {
            insurers: {
                type: Object,
                default: () => [],
            },
            params: {
                type: Object,
                default: this.$route.params,
                any: this.$route.params.any,
            },
            loading: 0,
            languages: [],
            pageData: null,
            happyKidsTutorialSubCategory: null,
            happyKidsInsurer: null,
            pagesValid: {
                insurer: null,
                productCat: null,
            },
        };
    },
    computed: {
      pageLoading() {
        return this.pagesValid.insurer === null &&
        this.pagesValid.productCat === null
      },
      dataLoading() {
        return !this.isEventTrackingReady;
      }
    },
    watch: {
      pagesValid: {
        handler(newVal, oldVal) {
          if ( this.pagesValid.insurer === false &&
                this.pagesValid.productCat === false ) {
            return this.$nuxt.error({ statusCode: 404, message: 'Page not found' });
          }
        },
        deep: true
      }
    },
    apollo: {
        $loadingKey: "loading",
        insurer: {
            prefetch: true,
            query: fiveStarInsurerByYearAndSlug,
            variables() {
                return { currentlocale: this.$normalizeLocale(this.$i18n.locale) , year: '2025', slug: this.$route.params.any};
            },
            update(data) {
                return this.$normalizeStrapi(data?.fiveStarInsurers?.data[0]);
            },
            result({ data }) {
                this.pagesValid.insurer = Boolean(this.insurer);

            },
        },
        productCat: {
            prefetch: true,
            query: fiveStarCatByYearAndSlug,
            variables() {
                return { currentlocale: this.$normalizeLocale(this.$i18n.locale) , year: '2025', slug: this.$route.params.any};
            },
            update(data) {
                return this.$normalizeStrapi(data.fiveStarCategories.data);
            },
            result({ data }) {
                this.pagesValid.productCat = Boolean(this.productCat.length);

            },
        },
        productCats: {
            prefetch: true,
            query: fiveStarPageByYear,
            variables() {
                return { currentlocale: this.$normalizeLocale(this.$i18n.locale) , year: '2025'};
            },
            update(data) {
                if (data && data?.fiveStarPages && data?.fiveStarPages?.data) {
                    return this.$normalizeStrapi(data.fiveStarPages.data);
                }

                console.debug('*** data err ***')
                return null
            },
            result({ data }) {

            },
        },
    },
}
